module.exports = __webpack_public_path__ + "static/img/IMG_2515.959529a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/10/IMG_2515.jpg
// module id = 654
// module chunks = 0